import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import axios from 'axios';
import { getHeaders } from '../../../request/index';
import { SttAutocomplete } from '@stt-componentes/core';
import { UF, MUNICIPIO, INSTITUICAO } from '../fieldNames';
import { MODALIDADE, PERFIL } from '../../../common/Constants';
import { useSignal } from '@preact/signals-react';
import { temPerfilRBAC } from '../../../security/acl';
import usuario from '../../../signals/usuario';
import { batch } from '@preact/signals-react';

const Municipio = ( props ) => {
	const { strings } = props;
    const { values } = useFormikContext();

    const municipios = useSignal([]);
    const instituicoes = useSignal([]);
    const filtroPorLocal = useSignal(false);
    const filtroPorRede = useSignal(false);
    const filtroPorFuncionario = useSignal(false);
    const carregarUfs = useSignal(false);   
    
    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    useEffect(() => {
        if (temPerfilRBAC(usuario, [PERFIL.ADMINISTRADOR, PERFIL.ADMINISTRADOR_ESTADUAL])) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
                filtroPorRede.value = true;
                filtroPorFuncionario.value = true;
            });
        }
        if (temPerfilRBAC(usuario, PERFIL.MEDICO_SOLICITANTE)) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
            });
        }
        if (temPerfilRBAC(usuario, PERFIL.VISUALIZADOR_REDE)) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
            });
        }
    }, []);
    
    useEffect(() => {
        const ufSelecionada = values[UF];
        municipios.value = [];

        if (filtroPorLocal.value && ufSelecionada) {
            axios.get(`${UTILITARIOS_API_BASE_URL}/localizacao/cidade?id-estado=${ufSelecionada.id}`, { headers: getHeaders() })
                .then((response) => {
                    const { itens } = response.data.data;
                    municipios.value = itens;
                })
                .catch(err => console.log(err));
        }
    }, [values[UF]]);

    const handleChangeMunicipio = (municipio) => {
        instituicoes.value = [];
        if (filtroPorLocal.value && municipio) {
            axios.get(`${UTILITARIOS_API_BASE_URL}/instituicao-equipamento?municipio=${municipio.id}&modalidade=${MODALIDADE.SIGLA}`, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        instituicoes.value = itens;
                    } else {
                        instituicoes.value = [];
                    }
                })
                .catch(err => console.log(err));
        }
    }

    return (
        <Field name={MUNICIPIO}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                    name: name,
                    label: strings.municipio
                }}
                    getOptionLabel={option => option?.nome || ''}
                    getOptionSelected={(option, val) => option?.id === val?.id}
                    options={municipios.value}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(MUNICIPIO, item || null);
                        setFieldValue(INSTITUICAO, null);
                        handleChangeMunicipio(item);
                    }}
                    disabled={!values[UF]}
                />
            )}
        </Field>
    );
};

export default Municipio;